export default __webpack_public_path__ + "static/media/star.0e2a51af.svg";